import { makeStyles, useTheme } from '@material-ui/core';
import { KS_PURPLE } from '../theme/ksDigitalTheme';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
});

/**
 * KS Digital primærlogo (symbol + ordmerke). Geometri fra den offisielle SVG-en i
 * fiks-static-assets/www/img/logos/KS-Digital_primaerlogo.svg, viewBox beskåret til
 * selve logoen. Symbolet er alltid lilla; ordmerket følger sidepanelets tekstfarge,
 * slik at det blir hvitt på det mørkeblå panelet (jf. _hvit-tekst-varianten).
 */
export const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();
  const wordmarkFill = theme.palette.navigation?.color ?? '#001a58';

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="80.5 80.5 1029.5 241.6"
      role="img"
      aria-label="KS Digital"
    >
      <path
        fill={KS_PURPLE}
        d="M241.6,161.1h80.5v80.5h-80.5v-80.5ZM80.5,161.1c0,44.5,36.1,80.5,80.5,80.5v-80.5s-80.5,0-80.5,0h0M161.1,322.1c44.5,0,80.5-36.1,80.5-80.5h-80.5v80.5M241.6,80.5c-44.5,0-80.5,36.1-80.5,80.5h80.5v-80.5"
      />
      <path
        fill={wordmarkFill}
        d="M396,145.9h20.4v46.9c1.7-2.7,4.1-5.4,7.3-8.7l35.9-38.2h26.4l-45,46.6,51.3,64.3h-27.4l-37.7-49.9-10.9,11.4v38.5h-20.4v-110.9ZM496.8,218.8h21.5c1.1,15.4,13.6,23.3,28.3,23.3s22.2-4.4,22.2-15.2-6-13-18.2-15.4l-18.8-3.6c-17.4-3.3-31-13.6-31-31.4s18.2-33.4,43.2-33.4,43.2,14.9,44.5,36.4h-21.5c-.5-10.3-7.8-19-23.9-19s-21.5,5.1-21.5,14.3,7.4,11.6,18.7,13.8l18.7,3.6c17.3,3.3,30.9,13.1,30.9,31.7s-15.5,35.8-44,35.8-47.2-16.2-48.9-40.9ZM645.6,145.9h39.3c37.4,0,58.8,19.5,58.8,55.6s-20.1,55.3-58.3,55.3h-39.7v-110.9ZM722.4,201.5c0-23.9-13.1-38-38.6-38h-17.4v75.7h17.6c23.3,0,38.5-12,38.5-37.7ZM760.9,147.5h20.1v20.3h-20.1v-20.3ZM761.2,179.5h19.3v77.3h-19.3v-77.3ZM801.1,262.1h19.6c.3,9.2,6.2,14.6,16.6,14.6s18.7-6,18.7-17.6v-8.4c0-3.5.2-6.7.6-9.7-4.6,7-12,12.8-24.1,12.8-20.1,0-34.7-14.1-34.7-38.5s16.8-38.5,33.7-38.5,20.4,5.5,25,13.6c-.5-2.7-.6-4.8-.6-7.6v-3.5h19.3v74.9c0,25.3-15.7,37.5-38.5,37.5s-35.8-12.2-35.8-29.8ZM857.2,215.4c0-13.5-8.2-23.1-19.6-23.1s-20,9.7-20,23.1,8.2,23.1,20,23.1,19.6-9.7,19.6-23.1ZM896.6,147.5h20.1v20.3h-20.1v-20.3ZM896.9,179.5h19.3v77.3h-19.3v-77.3ZM948.6,232.7v-37.8h-17.6v-15.4h17.6v-27.9h19.3v27.9h19v15.4h-19v35c0,8.1,3.2,12.8,11.4,12.8s4-.2,5.9-.5v14.6c-1.9.6-6.5,1.4-11.4,1.4-16.5,0-25.2-8.2-25.2-25.5ZM1001.1,235.5c0-17.4,13.5-23.4,30.1-25.7l11.1-1.4c6.3-.8,8.6-3.2,8.6-7,0-5.4-4.4-10.1-12.7-10.1s-14.7,5.1-15.5,13.1h-20c1.3-16.2,14.4-27.6,34.4-27.6s33.1,12.7,33.1,34.4v45.4h-17.9v-3.2c0-2.5.3-4.9.8-7.4-4.1,7.6-12,13.5-25.3,13.5s-26.6-8.9-26.6-24.1ZM1051.4,226.8v-8.4c-1.7,1.6-4.4,2.4-9.2,3.3l-6.3,1.3c-9,1.7-15.2,4.8-15.2,11.7s5.4,10.6,12.2,10.6c10.3,0,18.5-7.6,18.5-18.5ZM1090.7,145.9h19.3v110.9h-19.3v-110.9Z"
      />
    </svg>
  );
};
